import React, { useContext, useEffect } from 'react';
import Calendar from 'react-calendar';
import { FirebaseContext } from '../../context/firebase';
import * as PROJECT_CODE from '../../constants/projectCode';
import './Calendar.scss';

function CalendarAppointment({
	setAppointmentDate,
	appointmentDate,
	agentSelected,
	agentIdSelected,
	setBookedTimeList,
}) {
	const { firebase } = useContext(FirebaseContext);

	useEffect(() => {
		console.log('agentId: ' + agentIdSelected);

		agentIdSelected &&
			firebase
				.database()
				.ref('/client_appointments/' + PROJECT_CODE.projectCode)
				.orderByChild('createrID')
				.equalTo(agentIdSelected)
				.on('value', (snapshot) => {
					var timeArr = [];
					snapshot.forEach((snap) => {
						var timeOfAppointment = snap.val()?.timeOfAppointment;
						timeArr.push(timeOfAppointment);
					});
					console.log('Time of appointments: ' + timeArr);
					setBookedTimeList(timeArr);
				});
	}, [agentIdSelected]);

	return (
		<div className={'client_calendar'}>
			<Calendar
				formatMonthYear={(locale, date) =>
					date.toLocaleString(locale, {
						month: 'short',
						year: 'numeric',
					})
				}
				onChange={setAppointmentDate}
				value={appointmentDate}
				minDate={new Date()}
				showFixedNumberOfWeeks={true}
			/>
		</div>
	);
}

export default CalendarAppointment;
